<template>
  <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
    <v-layout wrap>
      <v-flex xs12 class="pb-2">
        <v-card
          style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
        >
          <div v-if="loading" style="min-height: 400px;">
            <v-progress-linear
              :indeterminate="true"
              color="success"
            ></v-progress-linear>
            <v-layout align-center justify-center fill-height style="min-height: 400px;">
              <div class="text-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="success"
                  indeterminate
                ></v-progress-circular>
                <div class="mt-3 title grey--text">Loading Teacher Information...</div>
              </div>
            </v-layout>
          </div>
          <v-layout row justify-space-between v-if="!loading">
            <v-layout column class="ma-1 px-3">
              <v-card-text
                class="mb-0 pb-0 pt-2 pl-2"
                v-if="teacher && teacher.employeeID"
              >
                <div class="display-1 pt-2 font-weight-bold mb-0 ml-0">
                  {{ teacher.teacherH }}
                </div>
                <div class="ml-0 mt-4">
                  <div class="pl-3">
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Teacher:
                      </div>
                      <div>
                        {{ teacher.teacher }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Employee ID:
                      </div>
                      <div>
                        {{ teacher.employeeID }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Teacher Code:
                      </div>
                      <div>
                        {{ teacher.teacherCode }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Type:
                      </div>
                      <div>
                        {{ teacher.type }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Branch:
                      </div>
                      <div>
                        {{ teacher.branch }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Grade:
                      </div>
                      <div>
                        {{ teacher.class }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Section:
                      </div>
                      <div>
                        {{ teacher.section }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Building:
                      </div>
                      <div>
                        {{ teacher.building }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2" align-center>
                      <div class="font-weight-medium mr-2">
                        Alert Phone:
                      </div>
                      <div>
                        {{ teacher.alertPhone | phone }}
                      </div>
                      <!-- <v-icon
                        small
                        class="ml-2 edit-icon"
                        @click="openAlertPhoneDialog"
                        style="cursor: pointer; color: #4CAF50;"
                      >
                        mdi-pencil
                      </v-icon> -->
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Alert Time:
                      </div>
                      <div>
                        {{ teacher.alertTime }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Pin Number:
                      </div>
                      <div>
                        {{ teacher.pinNumber }}
                      </div>
                    </v-layout>

                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        SMS Notification:
                      </div>
                      <div class="sms-notification-toggle">
                        {{ teacher.smsNotification ? "ON" : "OFF" }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Connection Mode:
                      </div>
                      <div>
                        {{ teacher.connectionMode }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Allow Broadcast:
                      </div>
                      <div>
                        {{ teacher.allowBroadcast ? "Yes" : "No" }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Allow Charge CC:
                      </div>
                      <div>
                        {{ teacher.allowChargeCC ? "Yes" : "No" }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2" v-if="teacher.rejectTips">
                      <div class="font-weight-medium mr-2">
                        Reject Tips:
                      </div>
                      <div>
                        {{ teacher.rejectTips ? "Yes" : "No" }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2" v-if="teacher.lastCallAt">
                      <div class="font-weight-medium mr-2">
                        Last Call At:
                      </div>
                      <div>
                        {{ teacher.lastCallAt | time }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Tip Balance:
                      </div>
                      <div>
                        {{ teacher.tipBalance | currency }}
                      </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                      <div class="font-weight-medium mr-2">
                        Teacher Name Recording:
                      </div>
                      <audio
                        v-if="teacher.teacherNameRecording"
                        class="mb-2"
                        controls
                        style="height: 25px;"
                        :src="teacher.teacherNameRecording"
                      ></audio>
                    </v-layout>
                  </div>
                </div>
              </v-card-text>
            </v-layout>
          </v-layout>

          <v-spacer></v-spacer>

          <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openSpecialNeedsStudentView"
                        >
                            Spatial Needs Program
                        </v-btn>
                    </v-layout> -->
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card
          class="pa-3"
          style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
        >
          <v-tabs color="success" dark icons-and-text>
            <v-tabs-slider color="#fff"></v-tabs-slider>

            <v-tab href="#tips">
              Tips ({{ getTipCount() }})
              <v-icon>mdi-currency-usd</v-icon>
            </v-tab>

            <v-tab href="#tips-grouped">
              Tips Grouped ({{ getGroupedTipCount() }})
              <v-icon>mdi-currency-usd</v-icon>
            </v-tab>

            <v-tab href="#calls">
              Call Logs ({{ getCallLogCount() }})
              <v-icon>mdi-phone</v-icon>
            </v-tab>
            <v-tab href="#teacher-notifications">
              Notifications ({{ getNotificationsCount() }})
              <v-icon>mdi-bell</v-icon>
            </v-tab>

            <v-tab href="#messages">
              Messages ({{ messages.length }})
              <v-icon>mdi-message-text</v-icon>
            </v-tab>

            <v-tab-item value="tips">
              <dx-grid
                name="tip-grid"
                class="tip-grid"
                :beforeSetupGrid="beforeSetupGrid"
                :url="tipTransactionUrl"
                :columns="tipTransactionColumns"
                title="Tips"
                :hideHeader="true"
                ref="tipTransactionGrid"
                :onCellPrepared="onCellPrepared"
                :expandedOptions="{
                  enabled: true,
                  allowExpandingAll: true,
                  template: 'tip-transaction-details',
                }"
              ></dx-grid>
            </v-tab-item>

            <v-tab-item value="tips-grouped">
              <dx-grid
                class="tip-grid"
                name="tip-grid-grouped"
                :beforeSetupGrid="beforeSetupGrid"
                :url="tipUrl"
                :columns="tipColumns"
                title="Tips"
                :hideHeader="true"
                ref="tipGrid"
                :expandedOptions="{
                  enabled: true,
                  allowExpandingAll: true,
                  template: 'tip-details',
                }"
              ></dx-grid>
            </v-tab-item>

            <v-tab-item value="calls">
              <dx-grid
                class="tip-grid"
                name="teacher-call-logs"
                :beforeSetupGrid="beforeSetupGrid"
                :url="callsUrl"
                :columns="callsColumns"
                title="Calls"
                :hideHeader="true"
                ref="callsGrid"
                :expandedOptions="{
                  enabled: true,
                  allowExpandingAll: true,
                  template: 'student-call-details',
                }"
              ></dx-grid>
            </v-tab-item>

            <v-tab-item value="teacher-notifications">
              <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
              ></v-progress-linear>
              <v-card
                v-if="!loading"
                class="pb-3 pt-1 px-2"
                style="background-color:#f1ffdc"
              >
                <v-layout
                  v-if="!teacherNotificationsToDisplay.length"
                  justify-center
                  align-center
                  class="my-3 headline"
                >
                  No Notifications
                </v-layout>
                <div v-if="teacherNotificationsToDisplay.length">
                  <v-card
                    class="pb-4 pt-2 px-3 my-3"
                    v-for="(teacherNotification,
                    index) in teacherNotificationsToDisplay"
                  >
                    <v-layout row class="px-3 pb-1 pt-3">
                      <div class="font-weight-medium mr-2 width-200">
                        Date:
                      </div>
                      <div>
                        {{ teacherNotification.date | time }}
                      </div>
                    </v-layout>
                    <v-layout
                      row
                      class="px-3 py-1"
                      v-if="teacherNotification.phoneNumber"
                    >
                      <div class="font-weight-medium mr-2 width-200">
                        Phone:
                      </div>
                      <div>
                        {{ formatPhoneNumber(teacherNotification.phoneNumber) }}
                      </div>
                    </v-layout>

                    <v-btn
                      class="mb-0"
                      @click="openActions(teacherNotification)"
                      color="success"
                      outline
                      small
                      >{{
                        teacherNotification.showActions
                          ? "Hide Actions"
                          : "Show Actions"
                      }}</v-btn
                    >

                    <div class="mt-4" v-if="teacherNotification.showActions">
                      <div
                        class="title"
                        v-if="!teacherNotification.actions.length"
                      >
                        No Actions
                      </div>
                      <div
                        class="dinner-ivr-detail-text px-3"
                        v-for="(action, index) in teacherNotification.actions"
                      >
                        <div class="layout row ">
                          <div class="mr-1  width-250">
                            {{ action.date }}
                          </div>
                          <div>
                            {{ action.title }}
                          </div>
                        </div>
                        <!-- <div class="layout row wrap mb-1 text--disabled">
                                                    <div>
                                                        {{ action.description }}
                                                    </div>
                                                </div> -->
                        <div class="layout row wrap mb-1 text--disabled">
                          <div v-if="action.inputDigits">
                            {{ action.inputDigits }}
                          </div>
                          <div v-if="action.response" class="px-1">
                            |
                          </div>
                          <div
                            v-if="action.eventType != 'START_PAYMENT_PROCESS'"
                          >
                            {{ action.response }}
                          </div>
                        </div>
                        <v-divider
                          class="py-2 mb-1"
                          v-if="index + 1 < teacherNotification.actions.length"
                        ></v-divider>
                      </div>
                    </div>
                  </v-card>
                </div>
                <v-layout justify-center>
                  <v-pagination
                    v-model="pagination.page"
                    :length="pages"
                    :total-visible="7"
                    v-on:input="setPagianation"
                  ></v-pagination>
                </v-layout>
              </v-card>
            </v-tab-item>

            <v-tab-item value="messages">
              <v-card
                class="pa-4"
                style="background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);"
              >
                <v-layout
                  v-if="!messages.length"
                  justify-center
                  align-center
                  class="my-5 headline grey--text"
                >
                  <v-icon large class="mr-2" color="grey"
                    >mdi-message-off</v-icon
                  >
                  No Messages
                </v-layout>

                <div v-if="messages.length">
                  <v-card
                    v-for="(message, index) in messagesToDisplay"
                    :key="message.id"
                    class="mb-3 elevation-2"
                    :style="{
                      borderRadius: '8px',
                      overflow: 'hidden',
                      borderLeft:
                        message.direction === 'OUT'
                          ? '5px solid #4CAF50'
                          : '5px solid #2196F3',
                    }"
                  >
                    <!-- Header Row -->
                    <v-layout
                      row
                      align-center
                      justify-space-between
                      class="mt-0 pb-1"
                      style="background-color: #f5f5f5; border-bottom: 1px solid #e0e0e0;"
                    >
                      <v-layout row align-center class="pt-3">
                        <!-- Direction Badge -->
                        <v-chip
                          small
                          :color="
                            message.direction === 'OUT' ? 'success' : 'primary'
                          "
                          text-color="white"
                          class="mr-3 ml-5"
                        >
                          <v-icon small left>
                            {{
                              message.direction === "OUT"
                                ? "mdi-arrow-up-circle"
                                : "mdi-arrow-down-circle"
                            }}
                          </v-icon>
                          {{
                            message.direction === "OUT" ? "Outbound" : "Inbound"
                          }}
                        </v-chip>

                        <!-- Status Badge -->
                        <v-chip
                          small
                          :color="getMessageStatusColor(message.status)"
                          text-color="white"
                          class="mr-3"
                        >
                          <v-icon small left class="white--text ml-1">{{
                            getMessageStatusIcon(message.status)
                          }}</v-icon>
                          <span class="mr-1">{{ message.status }}</span>
                        </v-chip>

                        <!-- Phone Numbers -->
                        <span
                          class="caption grey--text text--darken-2 d-flex align-center"
                        >
                          <v-icon x-small class="mr-1"
                            >mdi-phone-outgoing</v-icon
                          >
                          {{ formatPhoneNumber(message.from) }}
                          <v-icon x-small class="mx-1">mdi-arrow-right</v-icon>
                          {{ formatPhoneNumber(message.to) }}
                        </span>
                      </v-layout>

                      <!-- Date -->
                      <span class="caption grey--text text--darken-1 pt-1 mr-4">
                        {{ message.dateTime | time }}
                      </span>
                    </v-layout>

                    <!-- Message Text -->
                    <v-card-text class="py-3 px-4">
                      <div
                        class="body-2"
                        :style="
                          message.expanded
                            ? 'white-space: pre-line; line-height: 1.5;'
                            : ''
                        "
                      >
                        {{
                          message.expanded
                            ? message.text
                            : getFirstLine(message.text)
                        }}
                      </div>
                      <a
                        v-if="hasMultipleLines(message.text)"
                        class="success--text mt-1 d-inline-block"
                        style="font-size: 12px; cursor: pointer;"
                        @click="$set(message, 'expanded', !message.expanded)"
                        >{{ message.expanded ? "Show less" : "Show more" }}</a
                      >
                    </v-card-text>
                  </v-card>
                </div>
                <v-layout justify-center>
                  <v-pagination
                    v-model="messagePagination.page"
                    :length="messagePages"
                    :total-visible="7"
                    v-on:input="setMessagePagination"
                  ></v-pagination>
                </v-layout>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- SMS Consent Dialog -->
    <v-dialog v-model="smsConsentDialog" max-width="700" persistent>
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon dark class="mr-2">mdi-message-text</v-icon>
          SMS Notification Consent
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Privacy Policy Section -->
          <div class="mb-4">
            <div class="title mb-2">Privacy Policy</div>
            <v-divider class="mb-3"></v-divider>

            <div class="body-1 mb-3">
              <strong>Legal Entity Information:</strong><br />
              The user-facing brand,
              <strong>UTA (United Talmudical Academy)</strong>, is used as the
              consumer-facing name (Doing Business As - DBA) for the legally
              registered entity:
              <strong>United Talmudical Academy TORAH VYIRAH</strong>. All
              services, compliance, and legal responsibilities are covered under
              the full legal name.
            </div>

            <div class="body-1 mb-3">
              <strong>Data Privacy:</strong><br />
              We are absolutely committed to protecting your privacy. We will
              not share your mobile number, personal contact information, or
              messaging data (including text message content) with any third
              parties, partners, or affiliates for marketing or promotional
              purposes. Your data will not be sold or shared. This information
              is used strictly for the purpose of providing the Tip Notification
              service to which you have explicitly consented.
            </div>
          </div>

          <!-- Alert Phone Number Field -->
          <div class="mb-0">
            <v-text-field
              v-model="editAlertPhone"
              label="Alert Phone Number"
              prepend-icon="mdi-phone"
              placeholder="(555) 555-5555"
              outline
              color="success"
            ></v-text-field>
          </div>

          <!-- SMS Consent Checkbox Section -->
          <div
            class="consent-section pa-3"
            style="background-color: #f5f5f5; border-radius: 8px; border: 1px solid #e0e0e0;"
          >
            <v-checkbox
              v-model="smsConsentChecked"
              color="success"
              class="mt-0"
            >
              <template v-slot:label>
                <div class="body-1" style="line-height: 1.6;">
                  I agree to receive text messages for
                  <strong>Tip Notifications</strong> from <strong>UTA</strong>.
                  I understand message frequency varies and message and data
                  rates may apply. I know I can reply <strong>STOP</strong> to
                  cancel and <strong>HELP</strong> for assistance. I confirm I
                  have read the
                  <a
                    href="#"
                    @click.stop.prevent="openTermsOfServiceDialog"
                    class="success--text"
                    >Terms of Service</a
                  >
                  and
                  <a
                    href="#"
                    @click.stop.prevent="openPrivacyPolicyDialog"
                    class="success--text"
                    >Privacy Policy</a
                  >.
                </div>
              </template>
            </v-checkbox>
          </div>

          <!-- Additional Information -->
          <div class="mt-4 caption grey--text">
            <v-icon small class="mr-1">mdi-information</v-icon>
            This consent is optional. You may continue using the service without
            enabling SMS notifications.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="closeSmsConsentDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="saveSmsConsent">
            <v-icon left>mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Terms of Service Dialog -->
    <v-dialog v-model="termsOfServiceDialog" max-width="800" scrollable>
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon dark class="mr-2">mdi-file-document</v-icon>
          Terms of Service - SMS Notifications
        </v-card-title>

        <v-card-text class="pt-4" style="max-height: 500px;">
          <div class="terms-content">
            <div class="title mb-3">
              UTA SMS Notification Service Terms of Service
            </div>
            <div class="caption grey--text mb-4">
              Last Updated: December 2024
            </div>

            <div class="body-1 mb-4">
              <strong>1. Introduction</strong><br />
              These Terms of Service ("Terms") govern your use of the SMS
              notification service ("Service") provided by UTA (United
              Talmudical Academy), the consumer-facing brand name for the
              legally registered entity United Talmudical Academy TORAH VYIRAH
              ("we," "us," or "our"). By opting in to receive SMS notifications,
              you agree to be bound by these Terms.
            </div>

            <div class="body-1 mb-4">
              <strong>2. Service Description</strong><br />
              The UTA SMS Notification Service provides Tip Notifications to
              teachers and staff members. These messages are designed to alert
              you when tips have been received or when there are updates related
              to your tip balance and transactions.
            </div>

            <div class="body-1 mb-4">
              <strong>3. Message Frequency</strong><br />
              Message frequency varies based on tip activity and system
              notifications. You may receive messages when tips are received,
              processed, or when there are important updates related to the tip
              notification system. The number of messages you receive will
              depend on the volume of tip transactions associated with your
              account.
            </div>

            <div class="body-1 mb-4">
              <strong>4. Costs and Charges</strong><br />
              Message and data rates may apply. Standard messaging rates from
              your wireless carrier will apply to all SMS messages sent and
              received. Please contact your wireless carrier for details about
              your messaging plan and any associated costs.
            </div>

            <div class="body-1 mb-4">
              <strong>5. Opt-Out Instructions</strong><br />
              You may opt out of receiving SMS notifications at any time by
              replying <strong>STOP</strong> to any message you receive from us.
              Upon receiving your opt-out request, we will send you a
              confirmation message and remove your number from our messaging
              list. You will no longer receive SMS notifications after opting
              out.
            </div>

            <div class="body-1 mb-4">
              <strong>6. Help and Support</strong><br />
              For assistance with the SMS notification service, you may reply
              <strong>HELP</strong> to any message you receive. You will receive
              a response with contact information and basic instructions. You
              may also contact UTA administration directly for support.
            </div>

            <div class="body-1 mb-4">
              <strong>7. Consent Requirements</strong><br />
              By checking the consent checkbox and enabling SMS notifications,
              you expressly consent to receive automated text messages from UTA
              at the mobile phone number you have provided. This consent is not
              a condition of employment or any other service. You may decline to
              receive SMS notifications and still access all other services.
            </div>

            <div class="body-1 mb-4">
              <strong>8. Privacy</strong><br />
              Your privacy is important to us. Please review our Privacy Policy
              for information about how we collect, use, and protect your
              personal information, including your mobile phone number and
              messaging data.
            </div>

            <div class="body-1 mb-4">
              <strong>9. Modifications to Terms</strong><br />
              We reserve the right to modify these Terms at any time. Any
              changes will be effective immediately upon posting. Your continued
              use of the Service after any changes constitutes your acceptance
              of the new Terms.
            </div>

            <div class="body-1 mb-4">
              <strong>10. Contact Information</strong><br />
              If you have any questions about these Terms of Service, please
              contact:<br />
              <strong>UTA (United Talmudical Academy)</strong><br />
              Legal Entity: United Talmudical Academy TORAH VYIRAH<br />
              Email: helpdesk@utaw.org
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="termsOfServiceDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Privacy Policy Dialog -->
    <v-dialog v-model="privacyPolicyDialog" max-width="800" scrollable>
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon dark class="mr-2">mdi-shield-lock</v-icon>
          Privacy Policy - SMS Notifications
        </v-card-title>

        <v-card-text class="pt-4" style="max-height: 500px;">
          <div class="privacy-content">
            <div class="title mb-3">
              UTA SMS Notification Service Privacy Policy
            </div>
            <div class="caption grey--text mb-4">
              Last Updated: December 2024
            </div>

            <div class="body-1 mb-4">
              <strong>1. Legal Entity Information (DBA Disclosure)</strong
              ><br />
              The user-facing brand,
              <strong>UTA (United Talmudical Academy)</strong>, is used as the
              consumer-facing name (Doing Business As - DBA) for the legally
              registered entity:
              <strong>United Talmudical Academy TORAH VYIRAH</strong>. All
              services, compliance, and legal responsibilities described in this
              Privacy Policy are covered under the full legal name. When we
              refer to "UTA," "we," "us," or "our" in this policy, we are
              referring to United Talmudical Academy TORAH VYIRAH operating
              under the DBA name UTA.
            </div>

            <div class="body-1 mb-4">
              <strong>2. Information We Collect</strong><br />
              When you opt in to receive SMS notifications, we collect the
              following information:
              <ul class="mt-2">
                <li>Your mobile phone number</li>
                <li>Your consent status (opted in or opted out)</li>
                <li>Timestamp of your consent</li>
                <li>
                  Any responses you send to our messages (such as STOP or HELP)
                </li>
              </ul>
            </div>

            <div class="body-1 mb-4">
              <strong>3. How We Use Your Information</strong><br />
              We use the information we collect solely for the following
              purposes:
              <ul class="mt-2">
                <li>
                  To send you Tip Notification messages as described in our
                  Terms of Service
                </li>
                <li>To process your opt-out requests when you reply STOP</li>
                <li>To provide assistance when you reply HELP</li>
                <li>To maintain records of consent for compliance purposes</li>
              </ul>
            </div>

            <div
              class="body-1 mb-4"
              style="background-color: #e8f5e9; padding: 16px; border-radius: 8px; border-left: 4px solid #4CAF50;"
            >
              <strong>4. Data Privacy</strong><br /><br />
              <strong
                >We are absolutely committed to protecting your privacy.</strong
              ><br /><br />
              We will <strong>NOT</strong> share your mobile number, personal
              contact information, or messaging data (including text message
              content) with any third parties, partners, or affiliates for
              marketing or promotional purposes.<br /><br />
              <strong>Your data will NOT be sold or shared.</strong><br /><br />
              This information is used strictly for the purpose of providing the
              Tip Notification service to which you have explicitly consented.
              We do not sell, rent, trade, or otherwise transfer your mobile
              phone number or SMS data to any third party for their own
              marketing purposes.
            </div>

            <div class="body-1 mb-4">
              <strong>5. Message Content and Frequency</strong><br />
              The SMS messages you receive will contain Tip Notifications,
              including alerts about tips received, processed transactions, and
              balance updates. Message frequency varies depending on tip
              activity associated with your account. You may receive multiple
              messages per day during periods of high activity, or no messages
              during periods of no activity.
            </div>

            <div class="body-1 mb-4">
              <strong>6. Costs</strong><br />
              Message and data rates may apply based on your wireless carrier's
              messaging plan. UTA does not charge any fees for the SMS
              notification service itself, but standard carrier rates will
              apply.
            </div>

            <div class="body-1 mb-4">
              <strong>7. Your Rights and Choices</strong><br />
              You have the following rights regarding your SMS data:
              <ul class="mt-2">
                <li>
                  <strong>Opt-Out:</strong> Reply STOP to any message to stop
                  receiving SMS notifications
                </li>
                <li>
                  <strong>Help:</strong> Reply HELP to any message to receive
                  assistance
                </li>
                <li>
                  <strong>Access:</strong> Contact us to request information
                  about the data we hold
                </li>
                <li>
                  <strong>Deletion:</strong> Contact us to request deletion of
                  your SMS consent records
                </li>
              </ul>
            </div>

            <div class="body-1 mb-4">
              <strong>8. Data Security</strong><br />
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. Your mobile phone number
              and consent information are stored securely and access is limited
              to authorized personnel only.
            </div>

            <div class="body-1 mb-4">
              <strong>9. Data Retention</strong><br />
              We retain your consent records and mobile phone number for as long
              as you remain opted in to the service, and for a reasonable period
              thereafter for compliance and record-keeping purposes. If you opt
              out, we will retain a record of your opt-out request to ensure we
              do not send you further messages.
            </div>

            <div class="body-1 mb-4">
              <strong>10. Changes to This Privacy Policy</strong><br />
              We may update this Privacy Policy from time to time. Any changes
              will be posted with an updated "Last Updated" date. Your continued
              use of the SMS notification service after any changes constitutes
              your acceptance of the updated Privacy Policy.
            </div>

            <div class="body-1 mb-4">
              <strong>11. Contact Us</strong><br />
              If you have any questions about this Privacy Policy or our data
              practices, please contact:<br /><br />
              <strong>UTA (United Talmudical Academy)</strong><br />
              Legal Entity: United Talmudical Academy TORAH VYIRAH<br />
              Email: helpdesk@utaw.org
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="privacyPolicyDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Alert Phone Dialog -->
    <v-dialog v-model="alertPhoneDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon dark class="mr-2">mdi-phone</v-icon>
          Edit Alert Phone Number
        </v-card-title>

        <v-card-text class="pt-4 pb-0">
          <v-text-field
            v-model="editAlertPhone"
            label="Alert Phone Number"
            prepend-icon="mdi-phone"
            placeholder="(555) 555-5555"
            :rules="[rules.required]"
            outline
            color="success"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="closeAlertPhoneDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="saveAlertPhone">
            <v-icon left>mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";

export default {
  data: () => ({
    teacher: null,
    processing: false,
    loading: true,

    // SMS Consent Dialog
    smsConsentDialog: false,
    smsConsentChecked: false,
    termsOfServiceDialog: false,
    privacyPolicyDialog: false,

    // Alert Phone Dialog
    alertPhoneDialog: false,
    editAlertPhone: "",

    regID: "",

    tipUrl: "",
    tipTransactionUrl: "",
    callsUrl: "",

    pagination: {
      totalCount: 0,
      rowsPerPage: 5,
      page: 1,
    },

    messagePagination: {
      totalCount: 0,
      rowsPerPage: 5,
      page: 1,
    },

    teacherNotifications: [],
    teacherNotificationsToDisplay: [],

    messages: [],
    messagesToDisplay: [],

    tipTransactionColumns: [
      {
        field: "status",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        icon: (value, row) => {
          if (!value) return "";

          switch (value) {
            case "PROCESSED":
              return "mdi-check-circle";
            case "SCHEDULED":
              return "mdi-clock";
            case "VOIDED":
            case "CANCELED":
              return "mdi-cancel";
            case "ERROR":
              return "mdi-alert-circle";
            default:
              return "";
          }
        },
        iconColor: (value, row) => {
          if (!value) return "";

          switch (value) {
            case "PROCESSED":
              return "success";
            case "SCHEDULED":
              return "#fdb400";
            case "VOIDED":
            case "CANCELED":
              return "#aeb8bf";
            case "ERROR":
              return "#f35123";
            default:
              return "";
          }
        },
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name Hebrew",
        field: "nameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student Name",
        field: "studentName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Account ID",
        field: "accountID",
        link: "Account View",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Type",
        field: "type",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date",
        field: "date",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Amount",
        field: "amount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered On",
        field: "enteredOn",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Teacher Type",
        field: "teacherType",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mailing Address",
        field: "mailingAddress",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Read",
        field: "read",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Notified",
        field: "notified",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    tipColumns: [
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name Hebrew",
        field: "nameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student Name",
        field: "studentName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Account ID",
        field: "accountID",
        link: "Account View",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered On",
        field: "enteredOn",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date",
        field: "date",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Total Amount",
        field: "totalAmount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Payment Amount",
        field: "paymentAmount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Scheduled Amount",
        field: "scheduledAmount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    callsColumns: [
      {
        field: "phoneLine",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
          width: undefined,
        },
        icon: (value, row) => {
          switch (value) {
            case "PARENTS LINE":
              return "mdi-phone-incoming";
            case "STUDENTS LINE":
              return "mdi-phone-outgoing";
            case "TEACHERS LINE":
              return "mdi-account";
            default:
              return "";
          }
        },
        iconColor: (value, row) => {
          switch (value) {
            case "PARENTS LINE":
              return "#007827";
            case "STUDENTS LINE":
              return "#27a4d9";
            case "TEACHERS LINE":
              return "#11b99a";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        label: "Employee ID",
        field: "employeeID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Teacher",
        field: "teacherH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date",
        field: "date",
        type: "date",
        //template: "utc-to-est-template",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Duration",
        field: "duration",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Minutes",
        field: "minutes",
        visible: false,
        type: "number",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "From",
        field: "from",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "To",
        field: "to",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    rules: {
      required: (v) => {
        return !!v || "Required";
      },
    },
  }),
  computed: {
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(
            this.teacherNotifications.length / this.pagination.rowsPerPage
          )
        : 0;
    },
    messagePages() {
      return this.messagePagination.rowsPerPage
        ? Math.ceil(this.messages.length / this.messagePagination.rowsPerPage)
        : 0;
    },
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      await this.loadRegID();
      await this.loadTeacher();
      await this.loadTeacherNotifications();
      this.loadMessages();
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getRegID");
    },
    async loadTeacher() {
      const response = await this.$http.get(
        `odata/kesherEmployees?branch=&grade=&regID=${
          this.regID
        }&$filter=employeeID eq ${this.$route.params.id}`
      );

      this.teacher = response.value[0];

      if (response.value.length > 1) {
        this.teacher.type = response.value
          .map((teacher) => {
            return teacher.type;
          })
          .join(", ");
      }

      this.loading = false;
    },
    async loadTeacherNotifications() {
      const response = await this.$http.get(
        `api/teachers/getTeacherNotifications?employeeID=${
          this.$route.params.id
        }`
      );

      this.teacherNotifications = response.map((call) => {
        call.showActions = false;
        call.actions = [];

        return call;
      });

      this.teacherNotificationsToDisplay = response.slice(0, 5);
      this.pagination.totalCount = response.length;
      this.loading = false;
    },
    async loadMessages() {
      const response = await this.$http.get(
        `api/teachers/getMessages?employeeID=${this.$route.params.id}`
      );

      this.messages = response.map((message) => {
        message.text = message.text.trim();

        return message;
      });

      this.messagesToDisplay = response.slice(0, 5);
      this.messagePagination.totalCount = response.length;
    },
    beforeSetupGrid() {
      this.tipTransactionUrl =
        "tipTransactions?fromDate=&employeeID=" + this.$route.params.id;

      this.tipUrl = "tips?employeeID=" + this.$route.params.id;

      this.callsUrl = "schoolCalls?branch=&employeeID=" + this.$route.params.id;
    },
    getTipCount() {
      if (
        this.$refs.tipTransactionGrid &&
        this.$refs.tipTransactionGrid.dataSource.totalCount
      ) {
        return this.$refs.tipTransactionGrid.dataSource.totalCount();
      }
      return 0;
    },
    getGroupedTipCount() {
      if (this.$refs.tipGrid && this.$refs.tipGrid.dataSource.totalCount) {
        return this.$refs.tipGrid.dataSource.totalCount();
      }
      return 0;
    },
    getCallLogCount() {
      if (this.$refs.callsGrid && this.$refs.callsGrid.dataSource.totalCount) {
        return this.$refs.callsGrid.dataSource.totalCount();
      }
      return 0;
    },
    getNotificationsCount() {
      if (!this.teacherNotifications.length) return 0;

      return this.teacherNotifications.length;
    },
    getMessageStatusColor(status) {
      if (!status) return "#aeb8bf";
      switch (status.trim()) {
        case "ERROR":
        case "FAILED":
        case "UNDELIVERED":
          return "#f35123";
        case "NEW":
          return "info";
        case "QUEUED":
        case "WAITING":
        case "PENDING":
          return "#fdb400";
        case "DELIVERED":
          return "success";
        case "SENT":
        case "UNKNOWN":
          return "#aeb8bf";
        default:
          return "#aeb8bf";
      }
    },
    getMessageStatusIcon(status) {
      if (!status) return "";
      switch (status.trim()) {
        case "ERROR":
        case "FAILED":
          return "mdi-message-alert";
        case "NEW":
          return "mdi-message-plus";
        case "QUEUED":
        case "WAITING":
        case "PENDING":
          return "mdi-message-processing";
        case "SENT":
          return "mdi-comment-arrow-right";
        case "UNKNOWN":
          return "mdi-message-question";
        case "DELIVERED":
          return "mdi-message-text";
        case "UNDELIVERED":
          return "mdi-close-circle";
        default:
          return "";
      }
    },
    getFirstLine(text) {
      if (!text) return "";
      const firstLine = text.split("\n")[0];
      return firstLine.length > 100
        ? firstLine.substring(0, 100) + "..."
        : firstLine;
    },
    hasMultipleLines(text) {
      if (!text) return false;
      return text.includes("\n") || text.length > 100;
    },
    formatPhoneNumber(number) {
      return formatPhoneNumber(number);
    },
    setPagianation() {
      if (this.getSkip() >= this.pagination.totalCount) return;

      const number = (this.pagination.page - 1) * this.pagination.rowsPerPage;

      this.teacherNotificationsToDisplay = this.teacherNotifications.slice(
        number,
        number + this.pagination.rowsPerPage
      );
    },
    getSkip() {
      const page = this.pagination.page - 1;

      let skip = page * this.pagination.rowsPerPage;

      if (skip >= this.pagination.totalCount) {
        skip = this.pagination.totalCount - this.pagination.rowsPerPage;
      }

      return skip;
    },
    onCellPrepared(e) {
      // if (e.rowType === "data" && e.column.dataField === "amount") {
      //     e.cellElement.style.color = e.data.amount > 0 ? "green" : "red";
      //     e.watch(
      //         function() {
      //             return e.data.Amount;
      //         },
      //         function() {
      //             e.cellElement.style.color =
      //                 e.data.amount > 0 ? "green" : "red";
      //         }
      //     );
      // }
    },
    async openActions(call) {
      if (call.showActions) {
        call.showActions = false;
        return;
      }

      call.showActions = true;

      if (!call.actions.length) {
        const response = await this.$http.get(
          "api/studentCalls/getDetails?callUUID=" + call.callUUID
        );

        // call.actions = actions.map((action) => {
        //     action.date = moment(action.date).format("LTS");
        //     action.title =
        //         this.callActionsMap.get(action.eventType) ||
        //         action.eventType;
        //     action.description = this.getActionDescription(action);

        //     return action;
        // });

        call.actions = response.details.map((detail) => {
          detail.date = moment(detail.date).format("MM/DD/YYYY h:mm:ss A");

          detail.title = detail.eventType;

          return detail;
        });
      }
    },
    getActionDescription(action) {
      if (
        ["START_PAYMENT_PROCESS", "START_AUTOPAYSETUP_PROCESS"].includes(
          action.eventType
        )
      )
        return null;

      const inputActions = [
        "LOOKUP_PHONE",
        "VALIDATE_PHONE",
        "VALIDATE_PIN",
        "VALIDATE_CARD",
        "VALIDATE_EXP",
        "VALIDATE_SAVED_CARD",
      ];

      if (inputActions.includes(action.eventType)) {
        return action.inputDigits + " | " + action.response;
      }

      if (action.eventType == "CARD_PROCESSED_SUCCESS") {
        const pecies = action.response.split("|");
        const status = pecies.find((p) => p.startsWith("status")).substring(7);
        const amount = pecies.find((p) => p.startsWith("amount")).substring(7);

        return "$" + amount + " | " + status;
      }

      return action.response;
    },
    openSmsConsentDialog() {
      // Set the checkbox to match current SMS notification status
      this.smsConsentChecked = this.teacher.smsNotification || false;
      // Prefill the alert phone number
      this.editAlertPhone = this.teacher.alertPhone || "";
      this.smsConsentDialog = true;
    },
    closeSmsConsentDialog() {
      this.smsConsentDialog = false;
      this.smsConsentChecked = false;
      this.editAlertPhone = "";
    },
    saveSmsConsent() {
      // Save button is present but doesn't need to work per requirements
      // In the future, this would save the consent status:
      // this.teacher.smsNotification = this.smsConsentChecked;
      // await this.$http.post('api/teachers/updateSmsConsent', { ... });
      this.smsConsentDialog = false;
    },
    openTermsOfServiceDialog() {
      this.termsOfServiceDialog = true;
    },
    openPrivacyPolicyDialog() {
      this.privacyPolicyDialog = true;
    },
    openAlertPhoneDialog() {
      // Prefill with current alert phone number
      this.editAlertPhone = this.teacher.alertPhone || "";
      this.alertPhoneDialog = true;
    },
    closeAlertPhoneDialog() {
      this.alertPhoneDialog = false;
      this.editAlertPhone = "";
    },
    saveAlertPhone() {
      // Save button is present but doesn't need to work per requirements
      // In the future, this would save the phone number:
      // this.teacher.alertPhone = this.editAlertPhone;
      // await this.$http.post('api/teachers/updateAlertPhone', { ... });
      this.alertPhoneDialog = false;
    },
    setMessagePagination() {
      if (this.getMessageSkip() >= this.messagePagination.totalCount) return;

      const number =
        (this.messagePagination.page - 1) * this.messagePagination.rowsPerPage;

      this.messagesToDisplay = this.messages.slice(
        number,
        number + this.messagePagination.rowsPerPage
      );
    },
    getMessageSkip() {
      const page = this.messagePagination.page - 1;

      let skip = page * this.messagePagination.rowsPerPage;

      if (skip >= this.messagePagination.totalCount) {
        skip =
          this.messagePagination.totalCount -
          this.messagePagination.rowsPerPage;
      }

      return skip;
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}
.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}
.tip-grid.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}
.tip-grid .v-card__text {
  padding-top: 4px !important;
}
.tip-grid .flex {
  padding: 0px !important;
  padding-top: 24px !important;
}
.tip-grid .v-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
.sms-notification-toggle:hover {
  color: #388e3c !important;
  font-weight: 500;
}
.edit-icon:hover {
  color: #388e3c !important;
  transform: scale(1.2);
}
.consent-section .v-input--checkbox {
  margin-top: 0;
}
.consent-section .v-input__slot {
  align-items: flex-start !important;
}
.consent-section a {
  font-weight: 600;
}
.consent-section a:hover {
  text-decoration: underline;
}
.terms-content ul,
.privacy-content ul {
  padding-left: 20px;
  margin-bottom: 8px;
}
.terms-content li,
.privacy-content li {
  margin-bottom: 4px;
}
</style>
